<template>
  <div class="booth">
    <div v-for="(item, index) in boothList" :key="index">
      <div class="title">{{ item.bootTypeName }}</div>
      <table rules="none" cellspacing="0" align="center">
        <thead>
          <tr>
            <th>{{$t('exhiInformat.positionNumber')}}</th>
            <th>{{$t('exhiInformat.pavilion')}}</th>
            <th>{{$t('exhiInformat.boothArea')}}</th>
            <th>{{$t('exhiInformat.boothheight')}}</th>
            <th>{{$t('exhiInformat.boothType')}}</th>
            <th>{{$t('exhiInformat.affiliatedExhib')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ item.boothNum }}</td>
            <td>{{ item.boothName }}</td>
            <td>{{ item.boothArea + '㎡'}}</td>
            <td>{{ item.column15 + 'm'}}</td>
            <td>{{ item.column14 }}</td>
            <!-- <td>{{ item.column16 }}</td> -->
          </tr>
        </tbody>
      </table>
      <div class="box" v-if="item.boothImg">
        <div>{{$t('exhiInformat.bootheffect')}}:</div>
        <div class="imgBox">
          <el-image
            :src="baseUrl + item.boothImg"
            :preview-src-list="srcList"
          ></el-image>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import { getBooth } from "../../../../api/exhibitor";
import { forMat } from "../../../../utils/common";

export default {
  data() {
    return {
      imgbaseUrl: "",
      boothList: "",
      srcList: [],
      baseUrl: forMat(),
    };
  },

  created() {
    this.imgbaseUrl = forMat();
    this.getBooth();
  },

  methods: {
    spliceUrl(img) {
      // console.log(this.imgbaseUrl + img);
      return this.imgbaseUrl + img;
    },

    downloadAttachment(url, name) {
      let fileUrl = this.imgbaseUrl + url;
      const a = document.createElement("a");
      fetch(fileUrl)
        .then((res) => res.blob())
        .then((blob) => {
          // 将链接地址字符内容转变成blob地址
          a.href = URL.createObjectURL(blob);
          // console.log(a.href);
          // a.download = name+'.pdf' // 下载文件的名字
          // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
          let originname = url.split("/")[url.split("/").length - 1]; //获取原文件全称
          let type = originname.split(".")[originname.split(".").length - 1]; //获取原文件类型
          a.download = name + "." + type;
          document.body.appendChild(a);
          a.click();
        });
      // a.setAttribute('download', fileUrl);
      // a.setAttribute('href', fileUrl);
      // a.click(); // 自执行点击事件
    },
    async getBooth() {
      try {
        let lang=localStorage.getItem('lang')
        let { data } = await getBooth(lang);
        this.boothList = data.data;

        // console.log("当前展商的展位是：", this.boothList);
      } catch (e) {
        this.$message.error(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.booth {
  //   border: 1px solid red;
  .first {
    p {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      padding-bottom: 9px;
      border-bottom: 1px solid #e9e9e9;
    }

    .content {
      // padding: 26px 130px 0px 130px;
      margin: 26px 130px 0px 10px;

      .row {
        display: flex;
        padding-bottom: 26px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;

        .left {
          width: 220px;
          display: flex;
          // align-items: center;
          .name {
            width: 72px !important;
            text-align: right;
          }

          .picture {
            width: 227px;
            height: 175px;
            // border: 1px solid red;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .special {
          width: 303px;
        }

        .right {
          display: flex;
          width: 250px;
          align-items: center;

          .name {
            display: block;
            width: 61px;
            text-align: right;
          }
        }

        .last {
          .download {
            color: #006fb8;
            cursor: pointer;
          }
          .download:hover {
            color: rgba(0, 111, 184, 0.85);
          }
        }
      }

      .dajian {
        width: 80px !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
table {
  border-collapse: collapse;
  width: 82vw;
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  line-height: 22px;
}
table th {
  width: 250px;
  height: 32px;
  background: #006fb8;
  text-align: left;
  padding-left: 30px;
  box-sizing: border-box;
}
table tbody td {
  height: 42px;
  color: black;
  text-align: left;
  padding-left: 30px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
}

table tr:first-child th:first-child {
  border-top-left-radius: 4px;
}
table tr:first-child th:last-child {
  border-top-right-radius: 4px;
}
table tr:last-child td:first-child {
  border-bottom-left-radius: 4px;
}
table tr:last-child td:last-child {
  border-bottom-right-radius: 4px;
}
.title {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  margin-top: 10px;
  padding-bottom: 10px;
  // border-bottom: 1px solid #E9E9E9;;
}
.box {
  display: flex;

  margin-top: 20px;
  .imgBox {
    width: 220px;
    height: 170px;

    margin-left: 5px;
    img {
      width: 220px;
      height: 170px;
    }
  }
}
</style>
